import { useState } from "react";
import { ExclamationCircleIcon, ClipboardCopyIcon, CheckIcon } from "@heroicons/react/outline";

const PageViewFooter = ({bottomMenu, errorMessage=null, bottomMenuStyles=null}) => {
    const [copied, setCopied] = useState(false)

    if(!bottomMenu && !errorMessage){
        return <></>
    }

    // Walk a renderable (string, number, array, React element) to a plain
    // string. Avoids `String(jsxNode)` returning "[object Object]" when the
    // caller passed a fragment / element instead of a literal string.
    const extractText = (node) => {
        if (node == null || typeof node === 'boolean') return ''
        if (typeof node === 'string' || typeof node === 'number') return String(node)
        if (Array.isArray(node)) return node.map(extractText).join('')
        if (typeof node === 'object' && node.props) return extractText(node.props.children)
        return ''
    }

    const handleCopy = async () => {
        if (errorMessage == null) return
        const text = typeof errorMessage === "string"
            ? errorMessage
            : extractText(errorMessage)
        if (!text) return
        try {
            await navigator.clipboard.writeText(text)
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch (_) {
            // clipboard API can fail on insecure contexts — fall back to a
            // hidden textarea + execCommand so the operator can still copy.
            const ta = document.createElement('textarea')
            ta.value = text
            ta.style.position = 'fixed'
            ta.style.opacity = '0'
            document.body.appendChild(ta)
            ta.select()
            try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 1500) } catch (_) {}
            document.body.removeChild(ta)
        }
    }

    return (
        <div>
            {errorMessage && (
                <div>
                    <div className="bg-red-700 text-white text-3xl py-6 px-16 font-medium flex gap-4 items-center text-justify ">
                        <ExclamationCircleIcon className="h-10 flex-shrink-0" />
                        <span className="flex-1">{errorMessage}</span>
                        <button
                            type="button"
                            onClick={handleCopy}
                            title={copied ? "Copiado" : "Copiar mensaje"}
                            className="flex-shrink-0 p-2 rounded hover:bg-red-800 transition-colors"
                        >
                            {copied
                                ? <CheckIcon className="h-7 w-7" />
                                : <ClipboardCopyIcon className="h-7 w-7" />}
                        </button>
                    </div>
                </div>
            )}

            {bottomMenu && (
                <div className={`min-h-17 flex-shrink-0 bg-gray-100 ${bottomMenuStyles ? bottomMenuStyles : ""}`}>
                    {bottomMenu}
                </div>
            )}
        </div>
    )
}

export default PageViewFooter